import React from 'react';
import type { WidgetProps } from '@wix/yoshi-flow-editor';
import { AppWrapper } from 'root/components/Menus/AppWrapper/AppWrapper';
import { Widget, type MenuAddOnControllerProps } from './Widget';

const WrappedWidget = (props: WidgetProps<MenuAddOnControllerProps>) => (
  <AppWrapper>
    <Widget {...props} />
  </AppWrapper>
);

export { Widget };
export default WrappedWidget;
export type { ControllerProps, MenuAddOnControllerProps } from './Widget';
